export default "__VITE_ASSET__22f37449__"